export default class CartProduct {
    name: string;
    type: string;
    id: number;
    image: string;
    price: number;
    quantity: number;
    availableQuantity: number;
    finalPrice: number;
    // Backend status: "available", "reserved", "low_stock", "out_of_stock"...
    availability: string;
    isAvailable : boolean;
    designRequestExpired : boolean;
    itemId : number
  
    constructor({ name,type, id, image, price, quantity, availableQuantity, availability, designRequestExpired, itemId }: { name: string, type: string, id: number, image: string, price: number, quantity: number, availableQuantity: number, availability: string, designRequestExpired: boolean, itemId : number }) {
      this.name = name;
      this.id = id;
      this.image = image;
      this.price = price;
      this.quantity = quantity;
      this.availableQuantity = availableQuantity;
      this.finalPrice = quantity*price;
      this.availability = availability;
      this.isAvailable = availability === "available";
      this.type = type;
      this.designRequestExpired = designRequestExpired;
      this.itemId = itemId;
    }
  }

  